import {environment as baseEnv} from './environment.default';

const configuration = {
  production: true,
  environmentFile: 'prod',
  interactionGatewayUrl: 'https://interaction-gateway.gotthard.apgsga.ch/',
};
export const environment = Object.assign(baseEnv, configuration);
